import {
  Bot,
  Compass,
  Database,
  FileText,
  Lightbulb,
  Network,
  RefreshCcw,
  Search,
  type LucideIcon,
} from "lucide-react";

type ScopeIconName =
  | "Compass"
  | "Database"
  | "Bot"
  | "RefreshCcw"
  | "Lightbulb"
  | "Search"
  | "FileText"
  | "Network";

interface ScopeItem {
  title: string;
  description: string;
  iconName?: ScopeIconName;
}

interface ScopeGridProps {
  items: ScopeItem[];
}

export default function ScopeGrid({ items }: ScopeGridProps) {
  if (!Array.isArray(items) || items.length === 0) {
    throw new Error("ScopeGrid: `items` array is empty or invalid.");
  }

  const iconMap: Record<ScopeIconName, LucideIcon> = {
    Compass,
    Database,
    Bot,
    RefreshCcw,
    Lightbulb,
    Search,
    FileText,
    Network,
  };

  return (
    <div className="scope-grid">
      {items.map((item) => {
        const Icon = item.iconName ? iconMap[item.iconName] : null;
        if (item.iconName && !Icon) {
          throw new Error(`ScopeGrid: unsupported iconName "${item.iconName}".`);
        }

        return (
          <div className="scope" key={item.title}>
            {Icon ? (
              <span className="scope-ico" aria-hidden>
                <Icon size={20} strokeWidth={1.75} />
              </span>
            ) : null}
            <div className="scope-content">
              <h3>{item.title}</h3>
              <p dangerouslySetInnerHTML={{ __html: item.description }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
